import { LoadingOutlined } from '@ant-design/icons';
import { StyledDescription, StyledWrapper } from './index.styles';

export interface ILocalLoaderProps {
  className?: string;
  description?: string;
}

export function LocalLoader({ className, description }: ILocalLoaderProps) {
  return (
    <StyledWrapper className={className}>
      <LoadingOutlined style={{ fontSize: 34 }} spin />
      <StyledDescription>{description}</StyledDescription>
    </StyledWrapper>
  );
}
